<template lang="pug">
.c-article-list-section
  section-banner {{ title }}
  .section
    .container
      articleList(v-if="itemsToShow"
        :items="itemsToShow"
        @select="selectArticle")
      pagination-loader(:class="$style.pagination"
        :counterRef="counterRef"
        :counterKey="counterKey"
        :queryRef="queryRef"
        :total="total"
        :page="page"
        :length="length"
        :perPage="perPage"
        :lastDoc="lastDoc"
        @update:items="APPEND_ITEMS({ type, items: $event })"
        @update:total="UPDATE_PROPERTY({ type, data: { total: $event } })"
        @update:lastDoc="UPDATE_PROPERTY({ type, data: { lastDoc: $event } })"
        @update:page="$router.push({ query: { page: $event } })")
</template>

<script>
import { mapState, mapMutations } from "vuex";
import SectionBanner from "@/components/SectionBanner.vue";
import ArticleContent from "@/components/ArticleContent.vue";
import ArticleList from "@/components/ArticleList.vue";
import PaginationLoader from "@/components/PaginationLoader.vue";

export default {
  name: "ArticleListSection",
  components: {
    SectionBanner,
    ArticleContent,
    ArticleList,
    PaginationLoader,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      counterRef: this.$f.db.collection("counters").doc("articles"),
      counterKey: this.type,
      queryRef: this.$f.db
        .collection("articles")
        .where("type", "==", this.type)
        .where("published", "==", true)
        .orderBy("eventTime", "desc")
        .orderBy("creationTime", "desc"),
      perPage: 10,
    };
  },
  computed: {
    ...mapState("article", {
      total(state) {
        return state[this.type].total;
      },
      items(state) {
        return state[this.type].items;
      },
      lastDoc(state) {
        return state[this.type].lastDoc;
      },
    }),
    page() {
      return this.$route.query.page || 1;
    },
    length() {
      return this.items.length;
    },
    itemsToShow() {
      const start = (this.page - 1) * this.perPage;
      const end = start + this.perPage;
      const res = this.items.slice(start, end);
      return res;
    },
  },
  methods: {
    ...mapMutations("article", ["APPEND_ITEMS", "UPDATE_PROPERTY"]),
    selectArticle(article) {
      this.$router.push({
        name: "article",
        params: {
          type: this.type,
          id: article.temp.id,
        },
      });
    },
  },
};
</script>

<style module lang="sass">
.pagination
  padding: pxRem(24) 0
</style>
